import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { init } from '@plausible-analytics/tracker';
import './index.css';
import './i18n/config.js';
import App from './App.jsx';

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

// Plausible reads location.href during init. Remove the tags after that so the
// address bar stays clean, without changing the path or hash.
function stripUtm() {
  const url = new URL(window.location.href);
  let changed = false;
  for (const key of UTM_KEYS) {
    if (url.searchParams.has(key)) {
      url.searchParams.delete(key);
      changed = true;
    }
  }
  if (!changed) return;
  window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
}

// Both pages are served at revetall.ai. Other hostnames redirect here.
// Paths (/ and /smb/...) are what separate them in Plausible.
init({
  domain: 'revetall.ai',
});

if (document.visibilityState === 'hidden' || document.visibilityState === 'prerender') {
  document.addEventListener('visibilitychange', function onVisible() {
    if (document.visibilityState !== 'visible') return;
    document.removeEventListener('visibilitychange', onVisible);
    stripUtm();
  });
} else {
  stripUtm();
}

const root = document.getElementById('root');
const app = (
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// Prerendered pages already have markup. Hydrate it so crawlers and the app share one tree.
if (root.hasChildNodes()) {
  hydrateRoot(root, app);
} else {
  createRoot(root).render(app);
}
